export default __webpack_public_path__ + "static/media/race-item-bg-mobile.3590d368.png";